import AlpineStore from "./stores/AlpineStore";

//
// === Hydrate store ===
//

const { HYDRATE_VARIANT_ID } = window;

const urlSearchParams = new URLSearchParams(window.location.search);
const query = Object.fromEntries(urlSearchParams.entries());
const variantId = Number(query.variant) || HYDRATE_VARIANT_ID;

if (variantId) {
  Alpine.store("main").setActiveVariantId(variantId);
}
